import { render, staticRenderFns } from "./ActionPriorityButtons.vue?vue&type=template&id=a4623826&scoped=true"
import script from "./ActionPriorityButtons.vue?vue&type=script&lang=js"
export * from "./ActionPriorityButtons.vue?vue&type=script&lang=js"
import style0 from "./ActionPriorityButtons.vue?vue&type=style&index=0&id=a4623826&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4623826",
  null
  
)

export default component.exports